import { getConfig } from "@root/config/config";

export const checkCanOpenMuzaWidget = (link) => {
  const config = getConfig();
  const linkHaveWidget = link.match('\\/widgets\\/.{24}$');
  const linkAccepted = config.muzaWidget.acceptedUrls.find((url) => link.includes(url));

  return config.muzaWidget.openOnCurrentPage && linkAccepted && linkHaveWidget;
};

export const openMuzaWidget = (link) => {
  const iframeInstance = document.createElement('iframe');
  iframeInstance.id = `muza_widget-${link}`;
  iframeInstance.src = `${link}?openedFromRegion=${getConfig().theme}`;
  iframeInstance.style.position = 'fixed';
  iframeInstance.style.left = '0';
  iframeInstance.style.top = '0';
  iframeInstance.style.zIndex = '9999';
  iframeInstance.style.width = '100%';
  iframeInstance.style.height = '100%';

  document.body.appendChild(iframeInstance);
  document.body.style.overflow = 'hidden';
};

export const closeMuzaWidget = (link) => {
  const muzaWidgetIframe = document.getElementById(`muza_widget-${link}`);

  if (muzaWidgetIframe) {
    muzaWidgetIframe.remove();
  }

  document.body.style.overflow = 'auto';
};
